import { createContext, useEffect, useState, useCallback, useContext } from 'react'
import { SESSION_EXPIRED_EVENT } from '../utils/events'
import { queryClient } from '../queryClient'
import { CONFIG } from '../config/Config'

export const SessionContext = createContext(null)

export const SessionProvider = ({ children }) => {
  const [isSessionExpired, setIsSessionExpired] = useState(false)

  useEffect(() => {
    const handleSessionExpired = () => {
      console.warn('Session expired - redirecting to logout')
      setIsSessionExpired(true)

      // Clear React Query cache first to prevent stale data
      queryClient.clear()

      window.location.href = CONFIG.SSO_REDIRECT_PATH
    }

    window.addEventListener(SESSION_EXPIRED_EVENT, handleSessionExpired)

    return () => {
      window.removeEventListener(SESSION_EXPIRED_EVENT, handleSessionExpired)
    }
  }, [])

  const resetSession = useCallback(() => {
    // Clear React Query cache to prevent stale data
    queryClient.clear()

    window.location.href = CONFIG.SSO_REDIRECT_PATH
  }, [])

  const sessionContext = {
    isSessionExpired,
    resetSession,
  }

  return (
    <SessionContext.Provider value={sessionContext}>
      {children}
    </SessionContext.Provider>
  )
}

// Custom hook for using session context
export const useSession = () => {
  const context = useContext(SessionContext)
  if (!context) {
    throw new Error('useSession must be used within a SessionProvider')
  }
  return context
}